module.exports = __webpack_public_path__ + "img/A.f27e398c.png";